var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';
import './html-viewer.css';
import { TextArea } from '@philips-internal/oswald-ui-components/lib/components';
import { bool } from 'prop-types';
import { HtmlViewerAPI } from '.';
let HtmlViewer = class HtmlViewer extends Component {
    getDescription() {
        const { data, entry, description, value } = this.props;
        if (data) {
            return data[entry];
        }
        if (description) {
            return MessageService.translate(description);
        }
        return value;
    }
    isHtmlData() {
        const { isHtmlData } = this.props;
        return isHtmlData;
    }
    render() {
        return (React.createElement("div", { className: 'c-html-viewer' },
            this.isHtmlData() &&
                React.createElement("div", { className: 'c-html-viewer-content', dangerouslySetInnerHTML: { __html: this.getDescription() } }),
            !this.isHtmlData() &&
                React.createElement(TextArea, { value: this.getDescription(), rows: 7, readOnly: true })));
    }
};
HtmlViewer.propTypes = {
    description: string,
    entry: string,
    isHtmlData: bool,
    value: string,
};
HtmlViewer = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HtmlViewerAPI })
], HtmlViewer);
export default HtmlViewer;
//# sourceMappingURL=html-viewer.js.map